<template>
    <a-drawer
      placement="right"
      @close="onClose"
      :width="600"
      :visible="visible"
      destroyOnClose
    >
      <template slot="title">
        <a-button type="primary" ghost style="margin-right:10px;width:120px" @click="oneKey">一键排序</a-button>
        <a-button type="primary" ghost style="margin-right:10px;width:120px" @click="resetSort">清除排序</a-button>
        <a-button type="primary" style="width:120px" @click="submit">确定排序</a-button>
      </template>
      <template v-if="data.length">
          <div v-for="(item,index) in data" :key="index" >
            <div class="sTitle">
              <span>{{num_zn[index]}}、</span>
              <span>{{taskType(item.type)}}</span>
            </div>
            <li v-for="( el, indexS ) in item.data" :key="indexS" class="sortlist">
              <a-row>
                <a-col :span="20">
                  <span>{{indexS+1}}、</span>
                  {{el.title}}
                </a-col>
                <a-col :span="4">
                  <a-input type="number" placeholder="排序" class="noBorder" v-model="el.down_sort"/>
                </a-col>
              </a-row>
            </li>
          </div>
          <div style="padding:10px 0;text-align:center">
          </div>
      </template>
      <a-modal
          title="一键排序"
          :visible="pnumShow"
          @ok="handleOk"
          @cancel="handleCancel"
      >
        <a-input v-model="pnums" placeholder="输入数量分段排序" />
      </a-modal>
    </a-drawer>
</template>
<script>
// import draggable from 'vuedraggable'
import { num_zn, taskType } from '@/libs/transform'
export default {
    name: 'downSoltList',
    props:['visible', 'total', 'taskTypes'],
    // components:{ draggable },
    data(){
        return{
            pnumShow: false,
            num_zn,
            data:[],
            pnums: ''
        }
    },
    watch:{
        visible(val){
            if(val){
                this.data = this._.cloneDeep(this.taskTypes)
            }
        }
    },
    methods:{
        taskType,
        handleOk(){
          this.pnumShow = false
          if(this.pnums>0){
            const rounds = Math.floor(this.total / this.pnums); // 计算完整的轮数
            const remaining = this.total % this.pnums; // 计算剩余的题目数量

            let currentSort = 1; // 当前排序编号
            let ptotal = this.total - remaining
            // 初始化 down_sort 为 0 或其他默认值
            let keys=1;
            this.data.forEach((item, index) => {
              item.data.forEach((items, indexS) => {
                items.down_sort = '';
                items.keys = keys;
                keys++;
              });
            });

            for (let round = 0; round < rounds; round++) {
              for (let i = 0; i < this.pnums; i++) {
                const questionIndex = i * rounds + round + 1;
                if (questionIndex <= ptotal) {
                  this.data.forEach((item, index) => {
                    item.data.forEach((items, indexS) => {
                      if (items.keys === questionIndex) {
                        items.down_sort = currentSort;
                        currentSort++;
                      }
                    });
                  });
                }
              }
            }

            this.$forceUpdate();
          }
        },
        handleCancel(){
          this.pnumShow = false
        },
        onClose(){
            this.$emit('close' , false)
        },
        sortMaterial(){
            let marterArr = this.data.filter(el=>el.type == 'material')
            if(marterArr.length){
                marterArr.forEach((item,index)=>{
                    // types重组去重
                    let arrs =  []
                    this._.uniq(item.data.map(dd=>dd.type)).forEach((el,indexs)=>{
                        arrs.push(item.materialTask.filter( element=>element.type == el)[0])
                    })
                    item.materialTask = arrs
                })
            }
        },
        oneKey(){
          this.pnumShow = true
        },
        resetSort(){
          this.data.forEach((item,index)=>{
            item.data.forEach((items,indexs)=>{
              items.down_sort = ''
            })
          })
          this.$forceUpdate();
        },
        submit(){
            this.sortMaterial()
            this.$emit('soltList',this.data)
            this.onClose()
        }
    }
}
</script>
<style lang="less" scoped>
    .sTitle{
        font-size: 16px;
        line-height: 40px
    }
    .sortlist{
        padding:5px 10px;
        background: #eee;
        margin-bottom: 5px;
    }
</style>
